import * as React from "react";
import { Context } from "./_context";
export const NavigationPopForwardIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.677 3.056a.25.25 0 0 0-.354 0l-1.767 1.767a.25.25 0 0 0 0 .354L20.379 12l-6.823 6.823a.25.25 0 0 0 0 .354l1.767 1.767a.25.25 0 0 0 .354 0l7.884-7.884a1.5 1.5 0 0 0 0-2.12l-7.884-7.884Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationPopForwardIcon.iconId = "Cpkrvi";
